import { Icon } from '@iconify/react/dist/iconify.js';
import React, { useState } from 'react';

import MasterLayout from '../masterLayout/MasterLayout';
import Breadcrumb from '../components/Breadcrumb';
import UserDetails from '../components/UserDetails';

const UserPage = () => {

    return (
        <MasterLayout>
            {/* <Breadcrumb title={"User Details"} /> */}
            <UserDetails />
        </MasterLayout>
    );
};

export default UserPage;